enum PropertyDraftStatic {}

const PropertyDraftDynamic = {
  /**
   * @member {string}
   * @method get
   * @version 2.0
   * @description get property draft detail
   */
  DraftDetail: (id: string | number) => `/v3/admin/realestates/drafts/${id}`,

  /**
   * @member {string}
   * @method post
   * @version 2.0
   * @description update property draft
   */
  DraftUpdate: (id: string | number) =>
    `/v3/admin/realestates/drafts/${id}?_method=PUT`,

  /**
   * @member {string}
   * @method post
   * @version 2.0
   * @description delete all property drafts
   */
  DraftDelete: (id: string | number) => `/v3/admin/realestates/drafts/${id}`,

  /**
   * @member {string}
   * @method get
   * @version 2.0
   * @description get property drafts list
   */
  DraftList: "/v3/admin/realestates/drafts",

  /**
   * @member {string}
   * @method post
   * @version 2.0
   * @description delete multiple property drafts
   */
  DraftDeleteAll: "/v3/admin/realestates/drafts",

  /**
   * @member {string}
   * @method post
   * @version 2.0
   * @description Create  property drafts
   */
  DraftCreate: "/v3/admin/realestates/drafts",

  /**
   * @member {string}
   * @method post
   * @version 2.0
   * @description Upload image for property.
   */
  DraftUploadImage: (draft: string | number) =>
    `/v3/admin/realestates/drafts/${draft}/images`,
  /**
   * @member {string}
   * @method post
   * @version 2.0
   * @description Upload image for property.
   */
  DraftUploadDocument: (draft: string | number) =>
    `/v3/admin/realestates/drafts/${draft}/documents`,

  /**
   * @member {string}
   * @method delete
   * @version 2.0
   * @description Delete image from draft
   */
  DraftDeleteImage: (draft: string | number, image: string | number) =>
    `/v3/admin/realestates/drafts/${draft}/images/${image}`,

  /**
   * @member {string}
   * @method delete
   * @version 2.0
   * @description Delete document from draft
   */
  DraftDeleteDocument: (draft: string | number, document: string | number) =>
    `/v3/admin/realestates/drafts/${draft}/documents/${document}`
};

export const PropertyDraftEndpoints = {
  ...PropertyDraftDynamic,
  ...PropertyDraftStatic
};

export type PropertyDraftEndpoints = typeof PropertyDraftEndpoints;
